import { render } from "./userPassword.vue?vue&type=template&id=0944e306&scoped=true"
import script from "./userPasswordComponent.js?vue&type=script&lang=js"
export * from "./userPasswordComponent.js?vue&type=script&lang=js"

import "./userPassword.vue?vue&type=style&index=0&id=0944e306&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0944e306"]])

export default __exports__